
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    skill: {
      type: Object,
      required: true,
    },
    // bgcolors: {
    //   type: Array,
    //   required: true,
    // },
  },
});
